import {
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';

import { AllowedOrderByValues, type OrderBy } from '@common-lib';

import { AccountTypeModel } from '../account/account.model';
import { SearchFilterModel } from '../common';

export class SearchTransactionSortbyV2Model {
  @IsEnum(['RID', 'CREATED_AT', 'CLOSED_AT'])
  declare field: 'RID' | 'CREATED_AT' | 'CLOSED_AT';

  @IsEnum(AllowedOrderByValues)
  declare order: OrderBy;
}

export class SearchTransactionFilterV2Model extends SearchFilterModel {
  @IsOptional()
  @IsString({ each: true })
  declare siteUnitIds: string[] | undefined;

  @IsOptional()
  @IsString({ each: true })
  declare refundTransactionIds: string[] | undefined;

  @IsOptional()
  @IsString({ each: true })
  declare accountTypes: AccountTypeModel[] | undefined;

  @IsOptional()
  @IsString({ each: true })
  declare accountIds: string[] | undefined;

  @IsOptional()
  @IsString()
  declare from: string | undefined;

  @IsOptional()
  @IsString()
  declare to: string | undefined;

  @IsOptional()
  @IsString({ each: true })
  declare businessUnitIds: string[] | undefined;

  @IsOptional()
  @IsString({ each: true })
  declare checkRefs: string[] | undefined;

  @IsOptional()
  @IsNumber({}, { each: true })
  declare checkNumbers: number[] | undefined;
}

export class SearchTransactionV2Model {
  @IsOptional()
  @IsObject()
  @ValidateNested()
  declare filter: SearchTransactionFilterV2Model | undefined;

  @IsOptional()
  @IsNumber()
  declare pageSize: number | undefined;

  @IsOptional()
  @IsString()
  declare pageToken: string | undefined;

  @IsOptional()
  @IsObject()
  @ValidateNested()
  declare sortBy: SearchTransactionSortbyV2Model | undefined;
}
